import { dramaReel } from "@/mocks/blackdata";

export default function DramaReel() {
  return (
    <section id="drama" className="bg-background-950 text-background-100 mt-10 md:mt-14 scroll-mt-20">
      <div className="max-w-[1400px] mx-auto px-3 md:px-6 py-8 md:py-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 pb-5">
          <div>
            <span className="inline-flex items-center gap-1 rounded bg-secondary-600 text-background-50 px-2 py-0.5 text-[11px] whitespace-nowrap">
              <i className="ri-video-fill w-3.5 h-3.5 flex items-center justify-center"></i>
              录屏切片库
            </span>
            <h2 className="font-heading text-xl md:text-3xl text-background-50 mt-2">直播丑闻录屏 · 名场面切片</h2>
            <p className="text-[13px] md:text-sm text-background-300/90 mt-1">
              事故现场、情绪失控、翻脸名场面，完整录屏与关键片段均标注来源，提供下载入口。
            </p>
          </div>
          <a href="#download" className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 text-background-50 px-4 py-2.5 text-sm font-medium hover:bg-accent-600 transition-colors self-start md:self-auto">
            <i className="ri-download-cloud-2-line w-4 h-4 flex items-center justify-center"></i>
            批量下载切片包
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
          {dramaReel.map((d) => (
            <article key={d.id} className="group relative overflow-hidden rounded-lg bg-foreground-900 min-h-[240px] md:min-h-[300px] flex items-end">
              <img src={d.image} alt={d.title} className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/95 via-background-950/40 to-transparent"></div>
              {/* play */}
              <span className="absolute inset-0 m-auto flex h-14 w-14 items-center justify-center rounded-full bg-background-50/90 text-primary-700">
                <i className="ri-play-fill text-2xl w-6 h-6 flex items-center justify-center translate-x-0.5"></i>
              </span>
              <span className="absolute right-3 top-3 rounded bg-background-950/80 px-2 py-1 text-[11px] text-accent-400 backdrop-blur inline-flex items-center gap-1">
                <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center"></i>{d.time}
              </span>
              <div className="relative flex flex-col gap-1.5 p-4 w-full">
                <span className="inline-flex items-center gap-1 text-[11px] text-secondary-400 whitespace-nowrap">
                  <i className="ri-check-double-line w-3.5 h-3.5 flex items-center justify-center"></i>{d.tag}
                </span>
                <h3 className="text-[15px] md:text-base font-semibold text-background-50 leading-snug group-hover:text-accent-400 transition-colors">{d.title}</h3>
                <p className="text-[12px] text-background-300/90 line-clamp-1">{d.summary}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 pt-3 border-t border-background-50/10 text-[12px] text-background-400">
          <span className="inline-flex items-center gap-1.5"><i className="ri-shield-check-line w-3.5 h-3.5 flex items-center justify-center text-secondary-500"></i>切片均附原始来源与时间戳</span>
          <span className="inline-flex items-center gap-1.5"><i className="ri-list-check-3 w-3.5 h-3.5 flex items-center justify-center text-accent-500"></i>逐条支持跳转原文比对</span>
          <span className="inline-flex items-center gap-1.5"><i className="ri-refund-2-line w-3.5 h-3.5 flex items-center justify-center"></i>存疑条目已折叠标注</span>
        </div>
      </div>
    </section>
  );
}